import React, { useEffect } from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import BrowserLink from "found/Link";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";

import Page from "common/Page";
import logo from "common/images/hfa_logo.svg";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    form: {
      // marginTop: theme.spacing(6),
    },
    card: {
      // padding: `${theme.spacing(4)}px ${theme.spacing(3)}px`,
      // [theme.breakpoints.up('md')]: {
      //   padding: `${theme.spacing(8)}px ${theme.spacing(6)}px`,
      // },
    },
    cardHeader: {
      padding: theme.spacing(1, 2),
      textAlign: "center",
    },
    cardTitle: {
      fontSize: "1.25rem",
    },
    feedback: {
      marginTop: theme.spacing(2),
      textTransform: "capitalize",
    },
    title: {
      fontSize: 14,
    },
    error: {
      textTransform: "capitalize",
    },
    button: {
      // margin: theme.spacing(3, 0, 2),
      color: "white",
    },
    buttonWrapper: {
      position: "relative",
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -9,
      marginLeft: -12,
    },
    option: {
      fontSize: 15,
      "& > span": {
        marginRight: 10,
        fontSize: 18,
      },
    },
  })
);

export default function CreatePasswordMessage() {
  const classes = useStyles();

  useEffect(() => {
    document.title = "Email sent";
    // cleanUpDevices();
  }, []);

  return (
    <Page className={classes.root} title="Message">
      <Container maxWidth="xs">
        <Box p={1} m={1} justifyContent="center" textAlign="center">
          <img
            className={classes.root}
            src={logo}
            alt={process.env.REACT_APP_SITE_NAME}
          />
        </Box>

        <Card className={classes.card} raised>
          <CardHeader title="Email sent" />
          <Divider />
          <CardContent>
            <Typography component="div" variant="body2">
              We’ve recently upgraded our platform and need you to update your
              password. We've just sent you an email so please check your inbox
              and follow the instructions provided. If you have any questions
              contact us on{" "}
              <Link href="mailto:support@hedgefundalert.com">
                support@hedgefundalert.com
              </Link>
            </Typography>
          </CardContent>
          <Divider />
          <CardActions>
            <Grid container>
              <Grid item xs>
                <Link component={BrowserLink} to="/user/login">
                  Back to login
                </Link>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </Container>
    </Page>
  );
}
